// REDACTION 2 — magnitude deltas (+9pp CLV, +12% win prob) are
// hidden behind a tap-to-reveal "Why?" disclosure on each leg.
// Collapsed by default; expands on click. Per-leg local state.
// Never rendered in PDF export or share surfaces.
import { useState, type ReactNode, type ReactElement } from "react";

interface Props {
  children: ReactNode;
  label?: string;
}

export function WhyDisclosure({ children, label = "Why?" }: Props): ReactElement {
  const [open, setOpen] = useState(false);
  return (
    <span className="sr-why-disclosure" style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          style={{
            background: "transparent",
            border: "1px dashed var(--border)",
            color: "var(--text-tertiary)",
            fontSize: 10.5,
            fontWeight: 600,
            letterSpacing: "0.04em",
            padding: "3px 8px",
            borderRadius: 4,
            cursor: "pointer",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </button>
      )}
      {open && children}
    </span>
  );
}
